import { ThemedFunctor, TokenColor } from '@doveit/bricks';
import { css } from 'styled-components';

export const preview: ThemedFunctor = ({
  theme, $boxed, $aspectRatio, $height, $color,
}) => css`
  background-color: ${theme.color.background[$color as keyof TokenColor['background']].default.high};
  position: relative;
  overflow: hidden;

  ${$boxed && `
    border: 1px solid ${theme.color.border.neutral.default.high};
  `}

  ${$aspectRatio && `
    aspect-ratio: ${$aspectRatio};
  `}

  ${$height && `
    height: ${$height};
  `}
`;

export const fixedBox = () => css`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const imageWrapper = () => css`
  ${fixedBox()}
  inset: 0 0 auto;
`;

export const imagePlaceholder: ThemedFunctor = ({ theme, $color }) => css`
  ${fixedBox()}
  background-color: ${theme.color.background[$color as keyof TokenColor['background']].default.high};
  color: ${theme.color.background[$color as keyof TokenColor['background']].default.highest};
`;

export const typeBadge: ThemedFunctor = ({ theme }) => css`
  position: absolute;
  top: ${theme.remSize[200]};
  right: ${theme.remSize[200]};
  z-index: 1;
`;
